module.exports = __webpack_public_path__ + "static/media/contactBanner-akt.d5d708bb.jpg";